import { EventSource } from 'eventsource';

class EventSourceClient {
  constructor(url) {
    this.baseURL = process.env.REACT_APP_API_URL || 'http://localhost:3000';
    this.url = url;
    this.RECONNECT_DELAY = 5000;
    this.isConnecting = false;
    this.reconnectTimeout = null;
    this.es = null;
    this.eventHandlers = {};
  }

  connect() {
    if (this.isConnecting) {
      console.warn('Already connecting, skipping...');
      return this;
    }

    this.isConnecting = true;
    console.log('Starting connection...');

    this.es = new EventSource(`${this.baseURL}/api${this.url}`, {
      fetch: (input, init) =>
        fetch(input, {
          ...init,
          headers: {
            ...init.headers,
            'x-auth-token': localStorage.getItem('app-token'),
          },
          credentials: 'include'
        }),
    });

    this.setupEventListeners();
    return this;
  }

  subscribe(eventType, handler) {
    if (typeof handler !== 'function') {
      throw new Error('Handler must be a function');
    }

    if (!this.eventHandlers[eventType]) {
      this.eventHandlers[eventType] = [];
    }

    this.eventHandlers[eventType].push(handler);
    this.es.addEventListener(eventType, (event) => {
      this.eventHandlers[eventType].forEach((handler) => handler(event.data));
    });

    return this;
  }

  unsubscribe(eventType, handler) {
    if (this.eventHandlers[eventType]) {
      this.eventHandlers[eventType] = this.eventHandlers[eventType].filter(
        (h) => h !== handler
      );

      if (this.eventHandlers[eventType].length === 0) {
        this.es.removeEventListener(eventType);
      }
    }

    return this;
  }

  close() {
    clearTimeout(this.reconnectTimeout);
    Object.keys(this.eventHandlers).forEach((type) => {
      this.es.removeEventListener(type);
    });
    this.es.close();
    this.isConnecting = false;
    return this;
  }

  handleDisconnection() {
    this.close();
    console.log(`Attempting to reconnect in ${this.RECONNECT_DELAY} ms`);
    this.reconnectTimeout = setTimeout(() => {
      this.connect();
      Object.keys(this.eventHandlers).forEach((eventType) => {
        this.es.addEventListener(eventType, (event) => {
          this.eventHandlers[eventType].forEach((handler) => handler(event.data));
        });
      });
    }, this.RECONNECT_DELAY);
  }

  setupEventListeners() {
    this.es.addEventListener('open', () => {
      console.log('Connection established successfully!');
    });

    this.es.addEventListener('error', (error) => {
      console.log('Connection error:', error);
      this.handleDisconnection();
      if (error && error.code === 401) {
        // user not authorized
        localStorage.removeItem('app-token');
        localStorage.removeItem('app-user');
        window.location.href = '/login';
      }
    });

    this.es.addEventListener('close', () => {
      console.log('Connection close');
      this.handleDisconnection();
    });
  }
}

export default EventSourceClient;
